export function initCrmChat(url) {
    return new Promise((resolve, reject) => {
        // 解析 URL 参数
        function parseUrlParams(fullUrl) {
            try {
                const u = new URL(fullUrl);
                return {
                    baseUrl: u.origin, // 先取 https://api.go-chats.vip
                    pathname: u.pathname,
                    params: Object.fromEntries(new URLSearchParams(u.search).entries())
                };
            } catch (err) {
                console.error("URL 解析失败", err);
                return { baseUrl: '', pathname: '', params: {} };
            }
        }

        const { baseUrl, pathname, params } = parseUrlParams(url);

        // 去掉 /chat/index，只保留根域名
        const cleanUrl = pathname.includes('/chat/index') ? baseUrl : `${baseUrl}${pathname.replace(/\/chat\/index$/, '')}`;

        const merged = Object.assign(
            {
                openUrl: cleanUrl,
                token: params.token,
                isShowTip: false,
                windowStyle: 'center',
                noCanClose: params.noCanClose,
                ag: params.ag || '',
                openid: params.openid || '',
                sendUserData: {
                    uid: '',
                    nickName: '',
                    avatar: '',
                    kefu_id: params.kefu_id || '',
                    // openid: params.openid || ''
                }
            },
        );
        try {
            /* global initCustomerServer */
            const crm = new initCustomerServer(merged);
            crm.init();
            resolve(crm);
        } catch (e) {
            reject(e);
        }
    });
}
